module.exports = __webpack_public_path__ + "img/locfircover.54992cf7.png";